import { AdminOptionsState, AdminSettingsValues } from "./type";
import { ApplicationState } from "..";
import { LanguageCodes } from "../../constants/languages";

export const getOptionAbleToSeeAndModifyExistingPatientData = (state: AdminOptionsState) => {
    return state.ableToSeeAndModifyExistingPatientData;
}

export const getOptionAbleToSeeAndModifyExistingPreferredPharmacy = (state: AdminOptionsState) => {
    return state.ableToSeeAndModifyExistingPreferredPharmacy;
}

export const getOptionAbleToSeeAndModifyExistingPatientDataForSaga = (state: ApplicationState) => {
    return state.adminOptions.ableToSeeAndModifyExistingPatientData;
}

export const getOptionAbleToSeeAndModifyExistingPreferredPharmacyForSaga = (state: ApplicationState) => {
    return state.adminOptions.ableToSeeAndModifyExistingPreferredPharmacy;
}

export const getOptionRegionCodeConfirmationRequired = (state: AdminOptionsState) => {
    return state.regionCodeConfirmationRequired;
}

export const getOptionRegionCodeConfirmationRequiredForSaga = (state: ApplicationState) => {
    return state.adminOptions.regionCodeConfirmationRequired;
}

export const getDisplayProfilePicturesValue = (state: AdminOptionsState) => {
    return state.showProfilePictureDuringConfirmation;
}

export const getHealthCardExpirationRedirectToReceptionValue = (state: AdminOptionsState) => {
    return state.healthCardExpirationRedirectToReception;
}

export const getHealthCardExpirationRedirectToReceptionValueForSaga = (state: ApplicationState) => {
    return state.adminOptions.healthCardExpirationRedirectToReception;
}

export const getSelectedLanguages = (state: AdminOptionsState): Set<LanguageCodes> => state.useableLanguages;

export const getSessionTimeSpan = (state: AdminOptionsState): number => state.sessionTimeSpan;

export const getSelectedSiteIdForSaga = (state: ApplicationState) => state.adminOptions.siteId;

export const getSelectedSites = (state: ApplicationState) => state.adminOptions.multiSiteIds;

export const getAdminSettingFieldValues = (state: AdminOptionsState): AdminSettingsValues => ({
    sessionTimeSpan: state.sessionTimeSpan,
    inactivityDelay: state.inactivityDelay,
    latenessDelay: state.latenessDelay,
    maximumTimeGapBetweenAppointments: state.maximumTimeGapBetweenAppointments,
    checkInDelay: state.checkInDelay
})


// WEBPACK FOOTER //
// ./src/store/AdminOptions/selectors.ts